import { IcTab1, IcTab2 } from '@assets/icons/24x24';
import { Icon, IconButton } from '@chakra-ui/react';
import { useWindowManager } from '@components/cockpit/WindowManagerContext';

export default function ScreenButtons() {
  const { focusOrOpenWindow } = useWindowManager();

  return (
    <>
      <IconButton height="48px" width="fit-content" variant="cockpitHeader" onClick={() => focusOrOpenWindow(1)}>
        <Icon as={IcTab1} height="24px" width="36px" color="neutral.300" _groupHover={{ color: 'skyBlue' }} />
      </IconButton>
      <IconButton height="48px" width="fit-content" variant="cockpitHeader" onClick={() => focusOrOpenWindow(2)}>
        <Icon as={IcTab2} height="24px" width="36px" color="neutral.300" _groupHover={{ color: 'skyBlue' }} />
      </IconButton>
    </>
  );
}
